import React from 'react';
import { createContext, useContext } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';


export const SpecContext = createContext();

export const SpecProvider = ({ children }) => {

    const sp1opt = [
        "All Rounder",
        "Batting All Rounder",
        "Bowling All Rounder",
        "All Rounder Wicketkeeper",
        "Batsman",
        "Bowler",
        "Wicket Keeper",
        "Batter",
        "Other",
      ];
    
      const sp2opt = [
        "Right Hand",
        "Left Hand",
        "Right Hand Batsman",
        "Left Hand Batsman",
        "Right Hand Opener",
        "Left Hand Opener",
        "Right Hand Middle Order",
        "Left Hand Middle Order",
      ];
      
      const sp3opt = [
        "Right Arm Fast",
        "Right Arm Medium",
        "Left Arm Fast",
        "Left Arm Medium",
        "Off-Break",
        "Leg-Break",
        "Left Arm Orthodox",
        "Left Arm Chanaman",
      ];

      const ls = [
        "age",
        "fname",
        "cat",
        "detail",
        "tname",
        "tno",
        "tshirt",
        "trouser",
        "icon",
        "sp1",
        "sp2",
        "sp3",
        "receipt",
        "mobile",
      ];
      const defaultLabels = {
        age: "Age",
        mobile: "Mobile",
        fname: "Father's Name",
        cat: "Category",
        detail: "Detail",
        tname: "Jersey Name",
        tno: "Jersey Number",
        tshirt: "T-shirt Size",
        trouser: "Trouser",
        icon: "Icon",
        sp1: "Specification 1",
        sp2: "Specification 2",
        sp3: "Specification 3",
        receipt: "Receipt",
      };

      const initiallOptions = Object.fromEntries(
        ls.map((l, index) => [
          l,
          {
            s: l == "receipt" ? "0" : "1",
            r: "0",
            l: defaultLabels[l] || l,
            p: "",
            k: index + 1,
            o:
              l == "sp1"
                ? sp1opt
                : l == "sp2"
                ? sp2opt
                : l == "sp3"
                ? sp3opt
                : "null",
          },
        ])
      );


  const [state, setState] = useState({
    openSpec1: false,
    openSpec2: false,
    openSpec3: false,
    sp1Opt: sp1opt,
    sp2Opt: sp2opt,
    sp3Opt: sp3opt,
    newItem: "",
    newItem2: "",
    newItem3: "",
    field: {initiallOptions},
    showQrGuide: false,
  });



  const updateState = (key, value) => {
    console.log('hhhh')
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const addItem = (spec, label) => {
    console.log("Spec value:", spec);
    const trimmedItem =
  (label === "sp1" ? state.newItem :
  label === "sp2" ? state.newItem2 :
  label === "sp3" ? state.newItem3 : "")?.trim(); 
    if (trimmedItem === "") return;

    let updatedOptions = [];
    if (spec === "openSpec1") {
      updatedOptions = [...state.sp1Opt, trimmedItem];
      console.log(updatedOptions)
      updateState("sp1Opt", updatedOptions);
    } else if (spec === "openSpec2") {
      updatedOptions = [...state.sp2Opt, trimmedItem];
      console.log(updatedOptions)
      updateState("sp2Opt", updatedOptions);
    } else if (spec === "openSpec3") {
      updatedOptions = [...state.sp3Opt, trimmedItem];
      console.log(updatedOptions)
      updateState("sp3Opt", updatedOptions);
    }
    
    updateState("field", (prevField) => ({
      ...prevField,
      [state.field.k]: {
        ...prevField[state.field.k],
        o:
          label === "sp1"
            ? [...state.sp1Opt, trimmedItem]
            : label === "sp2"
            ? [...state.sp2Opt, trimmedItem]
            : label === "sp3"
            ? [...state.sp3Opt, trimmedItem]
            : "",
      },
    }));
    
    updateState("newItem", "");
    updateState("newItem2", "");
    updateState("newItem3", "");

  };

  // useEffect(() => {
  //   console.log(state.field.o);
  // }, [state.field]);

  const removeOption = (l, spec, optionToRemove) => {
    let updatedOptions = [];
    if (spec === "openSpec1") {
      updatedOptions = state.sp1Opt.filter((ele) => ele !== optionToRemove);
      updateState("sp1Opt", updatedOptions);
    } else if (spec === "openSpec2") {
      updatedOptions = state.sp2Opt.filter((ele) => ele !== optionToRemove);
      updateState("sp2Opt", updatedOptions);
    } else if (spec === "openSpec3") {
      updatedOptions = state.sp3Opt.filter((ele) => ele !== optionToRemove);
      updateState("sp3Opt", updatedOptions);
    }

    updateState("field", (prevField) => ({
      ...prevField,
      o: {
        ...prevField.o,
        [l]: {
          ...prevField.o[l],
          o: prevField.o[l]?.o?.filter((opt) => opt !== optionToRemove) || [],
        },
      },
    }));
    // console.log(state.field.o);

    console.log("Updated field:", state.field);
  };

  return (
    <SpecContext.Provider value={{state, setState, updateState, addItem,removeOption }}>
      {children}
    </SpecContext.Provider>
  );
};

export const useSpecState = () => {
    const context = useContext(SpecContext);
    if (!context) {
      throw new Error("useSpecState must be used within a <SpecProvider>");
    }
    return context;
  };

export default SpecProvider;
